import React, { useEffect, useState } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { dpsSend } from 'src/bff';
import { FormController, useOneFormContext, removeWhiteSpace } from 'src/feature-app';
import { getParamsForm } from 'src/feature-app/get-params-form';
import { OneElementTemplateFullScreen } from 'src/feature-app/Screen';
import { FormDataGroup, FormInfo, OneFormState, Steps } from 'src/types';
import { ThankYouBaja, BajaComunicacionesFields } from '.';
import { formDataBuilder, formatHeaders } from '../format-fields';
import { IdPerson } from 'src/types';
import { DpsData } from 'src/feature-service/es-oneform-core-feature-service/types';



let NuevoFormData: Partial<FormDataGroup> = {
  headers: {
    DESC_BRAND: 'VW',
    DESC_GDPR_ADAPTED: 'true',
    DESC_TOKEN: 'VW_DDB_FRM_BAJA_COMUNICACIONES',
    DESC_FORMOBJECTIVE: 'Baja Comunicaciones',
    COD_FORM_ID: 'vw-oneform-baja-comunicaciones',
  },
  fields: {
    formName: 'baja-comunicaciones',
    formType: 'otherform',
    pageCategory: 'Baja Comunicaciones',
  }, // Analítica
};

interface BajaComunicacionesProps {
  idPerson?: IdPerson;
  dpsData?: DpsData;
  campaign: string;
}

export const BajaComunicacionesForm = (props: BajaComunicacionesProps) => {
  const { initializeForm } = useOneFormContext();
  const { idPerson, campaign } = props;
  const store = useStore();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const steps: Steps[] = [
    {
      title: <></>, // El title se renderiza en los fields al ser un form de un solo step con un diseño que incluye un stage.
      fields: <OneElementTemplateFullScreen element={<BajaComunicacionesFields idPerson={idPerson}/>} />,
      screenIndex: 0,
      name: 'Form',
    },
  ];

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const info = urlParams.get('q');
    if (info) {
      const decodedParms = atob(info);
      const splittedParams = decodedParms.split(';');
      const [DESC_ID_CAMPAIGN, DESC_ID_CLIMAPRO] = splittedParams;

      NuevoFormData = {
        headers: { ...NuevoFormData.headers, DESC_ID_CLIMAPRO },
        fields: { ...NuevoFormData.fields },
      };
    }
    setLoading(false);
  }, []);

  const getFormInfo = (): {
    firstStep: Steps;
    lastStep: Steps;
    stepsHistory: number[];
    numberOfScreens: number;
    newSteps?: Steps[];
  } => {
    return {
      firstStep: steps[0],
      lastStep: steps[steps.length - 1],
      stepsHistory: [0],
      numberOfScreens: steps.length,
      newSteps: null,
    };
  };

  const sendForm = (): Promise<boolean> => {
    const { formData, dealersInfo }: OneFormState = store.getState();

    const { fields, headers } = formData;

    return new Promise<any>(async (resolve, reject) => {
      const { tc, today, referalUrl, url, device } = getParamsForm();

      //resolve(true);
      const data = {
        ...formatHeaders(headers),
        'headers[DESC_URLORIGIN]': url,
        'headers[FECHA_INSERTION_DATE]': today,
        'headers[TC]': tc,
        'headers[DESC_DEVICETYPE]': device,
        'headers[DESC_ID_CAMPAIGN]': campaign ? campaign : '',

        'fields[DESC_FORM_VERSION]': `vw-oneform-baja-comunicaciones-${process.env.VERSION}`,
        'fields[DESC_EMAIL_ADDRESS]': idPerson && idPerson.TXT_Email__c ? idPerson.TXT_Email__c : removeWhiteSpace(fields.email),
        'fields[DESC_REASON_CONTACT_CHANGE_REQ]': fields.motivoBaja,
        'fields[M_OBSERVATION]': fields.masInformacion,
        'fields[DESC_NAME]' : idPerson && idPerson.FirstName ? idPerson.FirstName : fields.name,
        'fields[DESC_SURNAME_1]' : idPerson && idPerson.LastName ? idPerson.LastName : fields.surname,
        'fields[DESC_SURNAME_2]' : idPerson && idPerson.TXT_2_Surname__c ? idPerson.TXT_2_Surname__c : fields.secondSurname,
        'fields[DESC_LSSI]': 'NO PERMITE',
      };
      const dataStringified = JSON.stringify(data);
      const dataParsed = JSON.parse(dataStringified);

      const formData = formDataBuilder(dataParsed);

      const response = await dpsSend(formData);

      if (response && response.data && response.data.content && response.data.content.code === '200') {
        dispatch({ type: 'SET_FORM_RESPONSE', payload: response.data });
        resolve(true);
      } else {
        resolve(false);
      }
    });
  };

  useEffect(() => {
    if (loading) {
      return;
    }
    const { firstStep, lastStep, stepsHistory, numberOfScreens, newSteps } = getFormInfo();

    const NuevoFormInfo: Partial<FormInfo> = {
      formStarted: true,
      sendFormCallback: sendForm,
      fullScreen: firstStep.fullScreen ? true : false,
      lastStep,
      numberOfScreens,
      formTheme: 'main',
      screenIndex: firstStep.screenIndex,
      step: firstStep,
      steps: newSteps ? newSteps : steps,
      stepsHistory,
      notALayer: true,
      formType: 'inPage',
      alingItemsCenter: true,
      thankYouComponent: <ThankYouBaja />,
    };
    initializeForm(NuevoFormInfo, NuevoFormData);
  }, [loading]);

  return !steps ? null : <FormController steps={steps} screenType="full-screen" />;
};
